<div class="container">
  <div class="row">
    <div class="col-12 d-flex justify-content-start gap-3 flex-wrap">
      <button class="btn btn-primary" [routerLink]="'add'">
        <i class="bi bi-plus me-2"></i>
        {{ 'add_family_member' | transloco }}
      </button>
    </div>
  </div>

  <div class="row g-3 mt-3">
    @for (i of familyMembers; track i.member.id; let idx = $index) {
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="h-100">
          <div class="card-header bg-body">
            <div class="d-flex flex-column align-items-center gap-2 text-center p-2">
              <div class="rounded-circle overflow-hidden img-container">
                @if (i.member.awsBucketAvatarKey) {
                  <img
                    class="img-fluid h-100 w-auto"
                    [src]="i.member.awsBucketAvatarKey | signedUrl: awsPath(i.member.id) | async"
                    alt="Patient avatar"
                  />
                } @else {
                  <i class="bi bi-person-circle text-secondary"></i>
                }
              </div>

              <h5 class="mt-2">{{ i.member | fullName }}</h5>

              @if (openedDetailIndex === idx) {
                <div class="mt-3 text-start w-100">
                  <div class="mb-2 d-flex align-items-center">
                    <strong class="me-1">{{ 'gender' | transloco }}:</strong>
                    <span class="me-2">{{ i.member.gender | transloco }}</span>
                    <i
                      class="bi bi-gender-{{ i.member.gender }}"
                      [ngStyle]="{
                        color: i.member.gender === 'male' ? '#3399cc' : 'hotpink',
                      }"
                    ></i>
                  </div>

                  <div class="mb-2">
                    <strong>{{ 'status' | transloco }}:</strong>
                    <span class="badge bg-{{ i.member.status }} ms-2">
                      {{ i.member.status | transloco }}
                    </span>
                  </div>

                  <div class="mb-2">
                    <strong>{{ 'phone' | transloco }}:</strong>
                    <span class="ms-2">{{ i.member.phone?.number }}</span>
                  </div>

                  <div class="mb-2">
                    <strong>{{ 'email' | transloco }}:</strong>
                    <span class="ms-2">{{ i.member.email }}</span>
                  </div>

                  <div class="mb-2">
                    <strong>{{ 'birthday' | transloco }}:</strong>
                    <span class="ms-2">
                      {{ i.member.birthDate | date: 'dd/MM/YYYY' }}
                    </span>
                  </div>
                </div>

                <a class="mt-1 cursor text-black-50 text-center" (click)="openModalInfo()">{{
                  'info_processing' | transloco
                }}</a>
              }

              <button class="btn btn-link p-0" (click)="toggleDetails(idx)">
                {{
                  openedDetailIndex === idx
                    ? ('measurement.collapse_list' | transloco)
                    : ('measurement.expand_list' | transloco)
                }}
              </button>
            </div>

            <div class="d-flex justify-content-center gap-2 flex-wrap mt-2">
              <button class="btn btn-outline-danger" (click)="openModal(i.id)">
                {{ 'delete_family_member' | transloco }}
              </button>
              <button [routerLink]="['family/edit', i.member.id]" class="btn btn-outline-secondary">
                {{ 'edit' | transloco }}
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>

<app-family-delete-confirmation-modal (confirm)="delete()"></app-family-delete-confirmation-modal>

<app-info-processing-modal
  [message]="'info_processing_patient'"
  [title]="'info_processing_patient_title'"
></app-info-processing-modal>
